mutation UploadPractice(
  $file: Upload!
  $sentence: ID!
  $aliyah: ID
  $haftarah: ID
  $sentenceGroup: ID
  $focusPoints: [FocusPointInput]
  $voiceEvents: [VoiceEventInput]
  $segmentPoints: [SegmentPointInput]
  $shared: Boolean
  $readOrder: String
  $voice: String
  $pronunciation: ID
  $torahMelody: ID
  $haftarahMelody: ID
  $sentenceGroupMelody: ID
) {
  uploadPractice(
    file: $file
    sentence: $sentence
    aliyah: $aliyah
    haftarah: $haftarah
    sentenceGroup: $sentenceGroup
    focusPoints: $focusPoints
    voiceEvents: $voiceEvents
    segmentPoints: $segmentPoints
    shared: $shared
    readOrder: $readOrder
    voice: $voice
    pronunciation: $pronunciation
    torahMelody: $torahMelody
    haftarahMelody: $haftarahMelody
    sentenceGroupMelody: $sentenceGroupMelody
  ) {
    ok
    errors
    id
  }
}
